// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login_login_main_container__QElVE {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
.Login_formContainer__5AsYg {
  width: 350px;
  height: auto;
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  border-radius: 10px;
  padding: 20px 30px;
  text-align: center;
  margin: 50px auto;
}

.Login_title__RRvBC {
  font-size: 28px;
  font-weight: 800;
  margin-bottom: 30px;
  font-family: "Lucida Sans", Geneva, Verdana, sans-serif;
}

.Login_form__kFnwI {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.Login_input__SJBGF {
  border-radius: 20px;
  border: 1px solid #c0c0c0;
  padding: 12px 15px;
  font-size: 16px;
  outline: none;
  transition: 0.3s;
  width: 100%;
}

.Login_input__SJBGF:focus {
  border-color: teal;
  box-shadow: 0 0 5px rgba(0, 128, 128, 0.3);
}

.Login_pageLink__RC8oF {
  text-align: right;
  font-size: 12px;
  color: #747474;
}

.Login_pageLinkLabel__1UGrC {
  cursor: pointer;
  font-weight: bold;
  text-decoration: underline;
}

.Login_pageLinkLabel__1UGrC:hover {
  color: black;
}

.Login_formBtn__A\\+ymN {
  padding: 12px;
  border-radius: 20px;
  background: teal;
  color: white;
  font-size: 16px;
  cursor: pointer;
  border: none;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  transition: 0.3s;
}

.Login_formBtn__A\\+ymN:hover {
  background-color: #005f5f;
}

.Login_signUpLabel__\\+qA4W {
  font-size: 12px;
  color: #747474;
  margin-top: 10px;
}

.Login_signUpLink__\\+K4X3 {
  font-weight: bold;
  color: teal;
  text-decoration: underline;
  cursor: pointer;
}

/* Responsive Design */
@media (max-width: 400px) {
  .Login_formContainer__5AsYg {
    width: 90%;
    padding: 20px;
  }

  .Login_title__RRvBC {
    font-size: 24px;
  }

  .Login_input__SJBGF {
    font-size: 14px;
  }

  .Login_formBtn__A\\+ymN {
    font-size: 14px;
    padding: 10px;
  }

  .Login_signUpLabel__\\+qA4W {
    font-size: 10px;
  }
}

.Login_passwordContainer__DMK\\+M {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}

.Login_passwordContainer__DMK\\+M input {
  width: 100%;
  padding-right: 40px; /* Space for the eye icon */
}

.Login_eyeIcon__fO6lg {
  position: absolute;
  right: 10px;
  cursor: pointer;
  color: #666;
  font-size: 18px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Login.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,4CAA4C;EAC5C,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB,EAAE,2BAA2B;AAClD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,WAAW;EACX,eAAe;AACjB","sourcesContent":[".login_main_container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n.formContainer {\n  width: 350px;\n  height: auto;\n  background-color: #fff;\n  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n  border-radius: 10px;\n  padding: 20px 30px;\n  text-align: center;\n  margin: 50px auto;\n}\n\n.title {\n  font-size: 28px;\n  font-weight: 800;\n  margin-bottom: 30px;\n  font-family: \"Lucida Sans\", Geneva, Verdana, sans-serif;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.input {\n  border-radius: 20px;\n  border: 1px solid #c0c0c0;\n  padding: 12px 15px;\n  font-size: 16px;\n  outline: none;\n  transition: 0.3s;\n  width: 100%;\n}\n\n.input:focus {\n  border-color: teal;\n  box-shadow: 0 0 5px rgba(0, 128, 128, 0.3);\n}\n\n.pageLink {\n  text-align: right;\n  font-size: 12px;\n  color: #747474;\n}\n\n.pageLinkLabel {\n  cursor: pointer;\n  font-weight: bold;\n  text-decoration: underline;\n}\n\n.pageLinkLabel:hover {\n  color: black;\n}\n\n.formBtn {\n  padding: 12px;\n  border-radius: 20px;\n  background: teal;\n  color: white;\n  font-size: 16px;\n  cursor: pointer;\n  border: none;\n  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n  transition: 0.3s;\n}\n\n.formBtn:hover {\n  background-color: #005f5f;\n}\n\n.signUpLabel {\n  font-size: 12px;\n  color: #747474;\n  margin-top: 10px;\n}\n\n.signUpLink {\n  font-weight: bold;\n  color: teal;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n/* Responsive Design */\n@media (max-width: 400px) {\n  .formContainer {\n    width: 90%;\n    padding: 20px;\n  }\n\n  .title {\n    font-size: 24px;\n  }\n\n  .input {\n    font-size: 14px;\n  }\n\n  .formBtn {\n    font-size: 14px;\n    padding: 10px;\n  }\n\n  .signUpLabel {\n    font-size: 10px;\n  }\n}\n\n.passwordContainer {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.passwordContainer input {\n  width: 100%;\n  padding-right: 40px; /* Space for the eye icon */\n}\n\n.eyeIcon {\n  position: absolute;\n  right: 10px;\n  cursor: pointer;\n  color: #666;\n  font-size: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"login_main_container": `Login_login_main_container__QElVE`,
	"formContainer": `Login_formContainer__5AsYg`,
	"title": `Login_title__RRvBC`,
	"form": `Login_form__kFnwI`,
	"input": `Login_input__SJBGF`,
	"pageLink": `Login_pageLink__RC8oF`,
	"pageLinkLabel": `Login_pageLinkLabel__1UGrC`,
	"formBtn": `Login_formBtn__A+ymN`,
	"signUpLabel": `Login_signUpLabel__+qA4W`,
	"signUpLink": `Login_signUpLink__+K4X3`,
	"passwordContainer": `Login_passwordContainer__DMK+M`,
	"eyeIcon": `Login_eyeIcon__fO6lg`
};
export default ___CSS_LOADER_EXPORT___;
